import { render, staticRenderFns } from "./xxcjConfig.vue?vue&type=template&id=1d314f6e&scoped=true"
import script from "./xxcjConfig.vue?vue&type=script&lang=js"
export * from "./xxcjConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d314f6e",
  null
  
)

export default component.exports